import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import "./Cgu.css";

const PolitiqueCookies = () => (

    <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        POLITIQUE DE COOKIES
      </Typography>

      <Divider className="cgu-divider" />

      <Typography variant="h6" gutterBottom>
        Qu’est-ce qu’un cookie ?
      </Typography>
      <Typography paragraph>
        Un cookie est un petit fichier texte enregistré sur votre terminal lors de votre navigation sur un site web. Il permet notamment de reconnaître votre appareil lors de vos prochaines visites.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Quels cookies utilisons-nous ?
      </Typography>
      <Typography paragraph>
        Notre site utilise les cookies suivants :
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        Cookies strictement nécessaires
      </Typography>
      <ul className="cgu-list">
        <li>Cookies de session : nécessaires au bon fonctionnement du site (connexion utilisateur, navigation sécurisée)</li>
      </ul>

      <Typography variant="subtitle1" gutterBottom>
        Cookies de mesure d’audience
      </Typography>
      <ul className="cgu-list">
        <li>Google Analytics : mesure l’audience du site, les pages visitées, le comportement utilisateur</li>
      </ul>

      <Typography variant="subtitle1" gutterBottom>
        Cookies marketing
      </Typography>
      <ul className="cgu-list">
        <li>Facebook Pixel, Google Ads : suivi des performances de nos campagnes publicitaires</li>
      </ul>

      <Typography variant="h6" gutterBottom>
        Consentement
      </Typography>
      <Typography paragraph>
        Lors de votre première visite, un bandeau de consentement s’affiche. Vous pouvez :
      </Typography>
      <ul className="cgu-list">
        <li>Accepter tous les cookies</li>
        <li>Refuser les cookies non essentiels</li>
        <li>Personnaliser vos choix</li>
      </ul>
      <Typography paragraph>
        Vous pouvez modifier votre consentement à tout moment via le gestionnaire JS-Cookie mis en place sur le site.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Gestion des cookies
      </Typography>
      <Typography paragraph>
        Vous pouvez également désactiver les cookies depuis les paramètres de votre navigateur.
      </Typography>
    </Box>
  </Container>
  <Footer />

  </>
);

export default PolitiqueCookies;
